export default __webpack_public_path__ + "locales/sq-AL/Profile.json?hash=120687f815209590a6f43030a9c72e8c";